import { PaperPlaneTilt, EnvelopeSimple } from "@phosphor-icons/react";

/* ============================================================================
 * WeeklyRecapCard — trigger a weekly-recap email preview to the owner.
 * ==========================================================================*/
export function WeeklyRecapCard({ onSend, sending }) {
  return (
    <section
      className="border border-white/10 bg-[#0a0a0a] p-6"
      data-testid="admin-weekly-recap"
    >
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <EnvelopeSimple size={18} weight="duotone" className="text-[#FF2A2A]" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-1">
              // weekly recap email
            </div>
            <h3 className="font-display text-xl font-extrabold tracking-tight">
              Every Monday · in your inbox
            </h3>
            <p className="mt-1 text-xs text-white/50 leading-relaxed max-w-xl">
              Last 7 days of installs, clicks, signups, best day. Preview it now to
              see exactly what lands in your inbox each Monday.
            </p>
          </div>
        </div>
        <button
          onClick={onSend}
          disabled={sending}
          data-testid="weekly-recap-send"
          className="border border-white/20 hover:border-[#FF2A2A]/60 hover:text-[#FF2A2A] disabled:opacity-60 text-white/85 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.22em] transition-colors inline-flex items-center gap-2"
        >
          <PaperPlaneTilt size={12} weight="bold" />
          {sending ? "Sending…" : "Send preview to owner"}
        </button>
      </div>
    </section>
  );
}
